import { render, staticRenderFns } from "./TouristPreviewNew.vue?vue&type=template&id=279d4bc4&"
import script from "./TouristPreviewNew.vue?vue&type=script&setup=true&lang=js&"
export * from "./TouristPreviewNew.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports